import { ApartmentStatus, ApartmentType, CurrencyType, typeOfComplexOptions } from "../types/propertyInventory/ApartmentComplex"

export const getComplexTypeText = (option: typeOfComplexOptions) => {
    switch(option) {
        case typeOfComplexOptions.Residencial:
            return "Residencial";
        case typeOfComplexOptions.Edificio:
            return "Edificio";
        case typeOfComplexOptions.Condominio:
            return "Condominio";
        case typeOfComplexOptions.Otro:
            return "Otro";
        default:
            return "Desconocido";
    }
}

export const apartmentTypes = [
        { value: ApartmentType.ESTUDIO, label: 'Estudio' },
        { value: ApartmentType.UN_DORMITORIO, label: '1 Dormitorio' },
        { value: ApartmentType.DOS_DORMITORIOS, label: '2 Dormitorios' },
        { value: ApartmentType.TRES_DORMITORIOS, label: '3 Dormitorios' },
        { value: ApartmentType.CUATRO_DORMITORIOS, label: '4 Dormitorios' },
    ];

    export const getApartmentTypeText = (type: ApartmentType) => {
        switch(type) {
            case ApartmentType.ESTUDIO:
                return "Estudio";
            case ApartmentType.UN_DORMITORIO:
                return "1 Dormitorio";
            case ApartmentType.DOS_DORMITORIOS:
                return "2 Dormitorios";
            case ApartmentType.TRES_DORMITORIOS:
                return "3 Dormitorios";
            case ApartmentType.CUATRO_DORMITORIOS:
                return "4 Dormitorios";
            default:
                return "Desconocido";
        }
    }

    export const currencies = [
        { value: CurrencyType.CRC, label: 'Colones (₡)' },
        { value: CurrencyType.USD, label: 'Dólares ($)' },
    ];

    export const statusOptions = [
        { value: ApartmentStatus.DISPONIBLE, label: 'Disponible', color: '#4CAF50' },
        { value: ApartmentStatus.OCUPADO, label: 'Ocupado', color: '#FF9800' },
        { value: ApartmentStatus.NO_DISPONIBLE, label: 'No Disponible', color: '#F44336' }
    ];


    export const formatCurrency = (
  value: number | string,
  currency: 'CRC' | 'USD',
  showSymbol: boolean = true
): string => {
  // Convertir a número si es string
  const numericValue = typeof value === 'string' ? parseFloat(value) : value;
  
  // Validar que sea un número válido
  if (isNaN(numericValue)) return showSymbol ? (currency === 'CRC' ? '₡0.00' : '$0.00') : '0.00';
  
  // Formatear el número con separadores de miles y decimales
  const formatted = new Intl.NumberFormat('es-CR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(numericValue);
  
  // Agregar símbolo si es necesario
  if (showSymbol) {
    return currency === 'CRC' ? `₡${formatted}` : `$${formatted}`;
  }
  
  return formatted;
};
    